// extracted by css-extract-rspack-plugin
var _1 = "uZqx4zTizu84k5Jo";
var _2 = "D5AwMvZ7ULUdQfS8";
var _3 = "cwV3AYpchlQU4VIH";
export { _1 as "container", _2 as "ellipsisInner", _3 as "movingInner" }
// extracted by css-extract-rspack-plugin
var _1 = "uZqx4zTizu84k5Jo";
var _2 = "D5AwMvZ7ULUdQfS8";
var _3 = "cwV3AYpchlQU4VIH";
export { _1 as "container", _2 as "ellipsisInner", _3 as "movingInner" }
